import React from 'react'
import { Route } from 'react-router-dom'
import { OrgSso } from './page/org-sso'

export const LayoutSso = () => {
  return (
    <React.Fragment>
      <Route path="/org/sso" component={OrgSso} />
    </React.Fragment>
  )
}
